import React, { useRef, useState } from "react";
import {
  videoShoppingIcon,
  contactUsIcon,
  locationIcon,
  ADDRESS_TEXT,
  ADDRESS_LINK,
  CLOSE_BLACK_IC,
} from "../../../assets";
import { Link } from "react-router-dom";

const GetInTouch = () => {
  const [bookDemoModel, setBookDemoModel] = useState(false);
  const modelRef = useRef(null);
  const bookDemoModelRef = useRef(null);

  const handleClickOutsideBookDemo = (event) => {
    if (
      bookDemoModelRef.current &&
      !bookDemoModelRef.current.contains(event.target)
    ) {
      setBookDemoModel(false);
    }
  };

  return (
    <div className="bg-[#F8F4F1]">
      <div className="">
        <div className="cormorant-medium text-primary text-center text-3xl lg:text-4xl pt-14 px-8 tracking-[1.15px]">
          GET IN TOUCH WITH US
        </div>
        <div className="lato-regular text-lg lg:text-xl text-[#1C1919] text-center   font-medium px-12">
          for a complete jewellery shopping experience!
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 px-8 gap-4 py-[30px] sm:py-[60px] ">
        <div className="relative group flex flex-col">
          <div className="absolute inset-0 bg-primary opacity-0 lg:group-hover:opacity-100 transform lg:group-hover:rotate-3 transition duration-300 translate-x-[-7px] rounded-xl"></div>
          <div className="relative bg-gradient-to-tr from-white via-white to-[#FCF5F0] rounded-xl shadow-md p-6 flex flex-col justify-between flex-1 overflow-hidden">
            <div className="relative z-10 flex-1">
              <h2 className="text-[#1C1919] cormorant-medium text-xl lg:text-2xl mb-2">
                Video Shopping
              </h2>
              <p className="lato-regular text-[#645E5E] xl:pr-16 ">
                Experience seamless video shopping with a personal touch—watch,
                explore, and instantly purchase your favorite products in
                real-time.
              </p>
            </div>
            <div className="w-full flex justify-end">
              <div
                onClick={() => setBookDemoModel(true)}
                className=" cursor-pointer w-fit relative z-10 flex justify-end items-center mt-4"
              >
                <span className="cormorant-medium bg-transparent border-[1px] border-primary text-primary px-5 py-[7px] rounded-full inline-block w-42">
                  BOOK NOW
                </span>
                <img
                  src={videoShoppingIcon}
                  alt="video shopping"
                  className="w-[40px] h-[40px] border-[1px] border-primary rounded-full p-2 "
                />
              </div>
            </div>
          </div>
        </div>
        <div className="relative group flex flex-col">
          <div className="absolute inset-0 bg-primary opacity-0 lg:group-hover:opacity-100 transform lg:group-hover:rotate-3 transition duration-300 translate-x-[-7px] rounded-xl"></div>
          <div className="relative bg-gradient-to-tr from-white via-white to-[#FCF5F0] rounded-xl shadow-md p-6 flex flex-col justify-between flex-1 overflow-hidden">
            <div className="relative z-10 flex-1">
              <h2 className="cormorant-medium text-[#1C1919]  text-xl lg:text-2xl mb-2">
                Our Store
              </h2>
              <p className="lato-regular text-[#645E5E] xl:pr-16 ">
                {ADDRESS_TEXT}
              </p>
            </div>
            <div className="relative z-10 flex justify-end items-center mt-4">
              <Link
                to={ADDRESS_LINK}
                target="_blank"
                className="cormorant-medium bg-transparent border-[1px] border-primary text-primary px-6 py-[7px] rounded-full inline-block w-32"
              >
                FIND US
              </Link>
              <img
                src={locationIcon}
                alt="our store"
                className="w-[40px] h-[40px] border-[1px] border-primary rounded-full p-2 "
              />
            </div>
          </div>
        </div>
        <div className="relative group flex flex-col">
          <div className="absolute inset-0 bg-primary opacity-0 lg:group-hover:opacity-100 transform lg:group-hover:rotate-3 transition duration-300 translate-x-[-7px] rounded-xl"></div>
          <div className="relative bg-gradient-to-tr from-white via-white to-[#FCF5F0] rounded-xl shadow-md p-6 flex flex-col justify-between flex-1 overflow-hidden">
            <div className="relative z-10 flex-1">
              <h2 className="cormorant-medium text-[#1C1919]  text-xl lg:text-2xl mb-2">
                Contact Us
              </h2>
              <p className="lato-regular text-[#645E5E] xl:pr-16 ">
                We're dedicated to providing you with exceptional support and a
                great experience!
              </p>
            </div>
            <div className="relative z-10 flex justify-end items-center mt-4">
              <Link
                to={"/contact-us"}
                className="cormorant-medium bg-transparent border-[1px] border-primary text-primary px-6 py-[7px] rounded-full inline-block w-32"
              >
                GET NOW
              </Link>
              <img
                src={contactUsIcon}
                alt="contact us"
                className="w-[40px] h-[40px] border-[1px] border-primary rounded-full p-2 "
              />
            </div>
          </div>
        </div>
      </div>
      {/* ==================== BOOK VIDEO CALL MODEL =============== */}
      {bookDemoModel && (
        <>
          <div
            onClick={handleClickOutsideBookDemo}
            className="fixed left-0 top-0 z-9999 flex h-full min-h-screen w-full items-center justify-center bg-black/50 px-4 py-5"
          >
            <img
              src={CLOSE_BLACK_IC}
              alt=""
              className="absolute right-2 top-2 bg-white rounded-full p-2 cursor-pointer"
              onClick={() => setBookDemoModel(false)}
            />
            <div
              ref={bookDemoModelRef}
              className={`small:w-[95%] md:w-[95%] lg:w-[60%] bg-white border-0 overflow-visible relative flex flex-col outline-none focus:outline-none`}
            >
              <iframe
                className={`w-full flex items-center justify-center h-[80vh]`}
                src="https://calendar.plushvie.in/daga/30min?duration=30"
              ></iframe>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-999 bg-black"></div>
        </>
      )}
    </div>
  );
};

export default GetInTouch;
